import React,{useEffect} from "react";
import { Link } from "react-router-dom";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import logo from "../assets/img/logo.png";
import login_bg from "../assets/img/login_bg.jpeg";
import { useState } from "react";
import Swal from 'sweetalert2';
import { post } from "../helper/api_helper"
import { useNavigate } from 'react-router-dom';
export default function Login() {
  const navigate = useNavigate();
  const initialFormState = {
    email_id: '',
    password: '',
  };
  const [formData, setFormData] = useState(initialFormState);
  const [validated, setValidated] = useState(false);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  useEffect(() => {
    const employee = localStorage.getItem("authEmployee");
    if (employee) {
      navigate("/dashboard");
    }
  }, [navigate]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      showAlert('error', 'Oops...', 'Please fill in all required fields.');
    } else {
      try {
        const response = await post("login", formData);
        if (response.status === 200) {
          showAlert('success', 'Login', response.message);
          localStorage.setItem("authEmployee", JSON.stringify(response));
          navigate("/dashboard");
        } else {
          showAlert('error', response.status, response.message);
        }
      } catch (err) {
        showAlert('error', 'Unexpected Error', err.message);
      }
    }
    setValidated(true);
  };
  const showAlert = (icon, title, text, timer = 2000) => {
    Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
  };
  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col className="d-none d-lg-block">
          <img src={login_bg} className="auth-img" alt="" />
        </Col>
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5"><img src={logo} width={"100%"}/></Link>
              <Card.Title>Sign In</Card.Title>
              <Card.Text>Welcome back! Please signin to continue.</Card.Text>
            </Card.Header>
            <Card.Body>
             <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
                <div className="mb-4">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" name="email_id" placeholder="Enter your email address" value={formData.email_id} onChange={handleChange} required />
                </div>
                <div className="mb-4">
                  <Form.Label className="d-flex justify-content-between">
                    Password <Link to="">Forgot password?</Link>
                  </Form.Label>
                  <Form.Control type="password" name="password" placeholder="Enter your password" value={formData.password} onChange={handleChange} required/>
                </div>
                <Button type="submit" className="btn-sign">Sign In</Button>
              </form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}